import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import fetchAction from "@/store/modules/fetchAction";
import commonStore from "@/store/modules/commonStore";

const store = new Vuex.Store({
  // strict: true,
  // strict: process.env.NODE_ENV !== 'production',
  modules: {
    fetchAction: fetchAction, //* 공통 API 통신 스토어
    commonStore: commonStore, //* 공통 스토어
  },
  // plugins: [createPersistedState({
  //   paths: ['searchStore']
  // })]
});

export default store;
